import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from './DuperbrowsePageWrapper';
import {
  getIsDuperbrowseActive,
  getCurrentItem,
  getIsLoading,
  getLastViewedItem,
} from '../redux/selectors';
import { exitDuperbrowse } from '../redux/actionCreators';

export type StateProps = Pick<
  Props,
  'isDuperbrowseActive' | 'currentItem' | 'isLoading' | 'justClosedAStream'
>;
export type DispatchProps = Pick<Props, 'exitDuperbrowse'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state): StateProps => ({
  isDuperbrowseActive: getIsDuperbrowseActive(state),
  currentItem: getCurrentItem(state),
  isLoading: getIsLoading(state),
  justClosedAStream: !!getLastViewedItem(state),
});

const mapDispatchToProps: DispatchProps = {
  exitDuperbrowse,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
) as (component: ComponentType<Props>) => ComponentType<OwnProps>;
